module.exports = __webpack_public_path__ + "static/media/help.1934f3e1.svg";